import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';

const PushNotificationsListenerProvider: ContainerComponent = ({
    children,
}) => {
    // No push notifications support for web.
    return <>{children}</>;
};

export default PushNotificationsListenerProvider;
